module.exports = __webpack_public_path__ + "20250721160708/img/data_stat.ff7f9882.png";